export default __webpack_public_path__ + "static/media/taskLocation.59595a65.svg";